module.exports = __webpack_public_path__ + "img/vote.8d4f659d.png";